import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class CustomerBillingSyncHistoryService
{
 private pathApi = this.config.setting['pathApi'] + 'customerSyncBillingHistory/';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) { }

    download(): Observable<any> {
      return this.http.get(`${this.pathApi}downloadFile`,{
        headers: this.headers,
        observe: 'response',
      });
    }
  
}